import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routes/AppRoutes";
import { ProductsProvider } from "./context/ProductsContext";
import { KeyboardProvider } from "./context/KeyboardContext";
import VirtualKeyboard from "./components/ui/VirtualKeyboard";

function App() {
  return (
    <KeyboardProvider>
      <ProductsProvider>
        <AppRoutes />
        <ToastContainer
          transition={Slide}
          limit={3}
        />
        <VirtualKeyboard />
      </ProductsProvider>
    </KeyboardProvider>
  );
}

export default App;
